<ng-container *ngIf="showCompleteProfile; else showLogin">
  <app-complete-profile
    [content]="content"
    [globalContent]="globalContent$ | async"
    (completeProfile)="updateUserDocument($event)"
  >
  </app-complete-profile>
</ng-container>
<ng-template #showLogin>
  <div class="login">
    <div class="login-sso">
      <h2 class="login-sso__heading">{{ content?.fields.heading }}</h2>
      <div class="login-sso-button-container">
        <button
          class="login-sso__button"
          (click)="
            authService.resetAuthSsoError();
            authService.signInWithPopupFacebook()
          "
        >
          <img
            class="login-sso__button-icon"
            src="/assets/icons/facebook-login.svg"
            alt="Facebook"
          />
          {{ content?.fields.facebookButtonText }}
        </button>
        <button
          class="login-sso__button"
          (click)="
            authService.resetAuthSsoError(); authService.signInWithPopupGoogle()
          "
        >
          <img
            class="login-sso__button-icon"
            src="/assets/icons/google-login.svg"
            alt="Google"
          />
          {{ content?.fields.googleButtonText }}
        </button>
      </div>
      <div
        class="login-sso__error-message"
        *ngIf="authSsoError$ | async as authSsoError"
      >
        {{ authSsoError.message }}
      </div>
    </div>

    <div class="divider-container">
      <div class="divider"></div>
      <span class="divider-text">{{ content?.fields.subheading }}</span>
      <div class="divider"></div>
    </div>
    <form [formGroup]="signInForm" (ngSubmit)="signInWithEmailAndPassword()">
      <div class="login-form__input-container">
        <input
          class="login-form__input"
          type="email"
          name="email"
          formControlName="email"
        />
        <label class="login-form__label" for="email">{{
          content?.fields.emailLabel
        }}</label>
        <span
          class="login-form__input-error"
          *ngIf="hasError(email, 'required')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationRequired }}
        </span>
        <span class="login-form__input-error" *ngIf="hasError(email, 'email')">
          {{ (globalContent$ | async)?.fields.inputValidationInvalidEmail }}
        </span>
      </div>

      <div class="login-form__input-container">
        <input
          class="login-form__input"
          type="password"
          name="password"
          formControlName="password"
        />
        <label class="login-form__label" for="password">{{
          content?.fields.passwordLabel
        }}</label>
        <span
          class="login-form__input-error"
          *ngIf="hasError(password, 'required')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationRequired }}
        </span>
        <span
          class="login-form__input-error"
          *ngIf="hasError(password, 'minlength')"
        >
          {{ (globalContent$ | async)?.fields.inputValidationTooShort }}
        </span>
      </div>

      <div
        class="login-form__form-error-container"
        *ngIf="formError$ | async as formError"
      >
        <span class="login-form__form-error">
          {{ (globalContent$ | async)?.fields.formValidationInvalidFields }}
        </span>
      </div>
      <div
        class="login-form__form-error-container"
        *ngIf="authError$ | async as authError"
      >
        <span class="login-form__form-error">
          {{
            (globalContent$ | async)?.fields.formValidationAuthenticationError
          }}
        </span>
      </div>

      <div class="login-form-submit">
        <button class="login-form-submit__button" type="submit">
          {{ content?.fields.ctaText }}
        </button>
      </div>
    </form>

    <div class="link-join-container">
      <a class="link-join" [routerLink]="content?.fields.alternateCtaLink">
        {{ content?.fields.alternateCtaText }}
      </a>
    </div>

    <div class="link-forgot-password-container">
      <a
        class="link-forgot-password"
        [routerLink]="(globalContent$ | async)?.fields.forgotPasswordLinkUrl"
      >
        {{ (globalContent$ | async)?.fields.forgotPasswordLinkText }}
      </a>
    </div>
  </div>
</ng-template>
